import React from 'react';

import Modal from "../../../../component/modal/ModalTemplate";

import * as stringUtil from '../../../../util/stringUtil';
import * as apiUtil from "../../../../util/apiUtil";
import Loading from "../../../../component/loading/Loading";

class PaymentUsageModal extends React.Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);
        this.getType = this.getType.bind(this);
        this.getMomentMessageType = this.getMomentMessageType.bind(this);
        this.handleRefund = this.handleRefund.bind(this);

        this.state = {
            loading: false,
        }
    }


    setLoading(loading) {
        this.setState({ loading: loading });
    }
    getType(type) {
        switch (type) {
            case 'M':
                return '사용';
            case 'R':
                return '복구';
            case 'P':
                return '충전';
            case 'F':
                return '환불';
            case 'N':
                return '미발송';
            default:
                return 'N/A';
        }
    }
    getMomentMessageType(messageType) {
        switch (messageType) {
            case 'WIDE_MESSAGE': return '카카오모먼트 - 와이드 이미지';
            case 'WIDE_LIST_MESSAGE': return '카카오모먼트 - 와이드 리스트';
            case 'CAROUSEL_FEED_MESSAGE': return '카카오모먼트 - 캐러셀 피드';
            case 'CAROUSEL_COMMERCE_MESSAGE': return '카카오모먼트 - 캐러셀 커머스';
            case 'BASIC_TEXT_MESSAGE': return '카카오모먼트 - 기본 텍스트';
            default: return messageType || '-';
        }
    }
    handleRefund() {
        if (! window.confirm("환불 신청 하시겠습니까?")) return;

        /* 신용카드, 실시간 계좌이체 환불 */
        const { paymentInfo, handleSuccessModal, handleClose, handleFailModal } = this.props;

        /*환불 금액이 부족할때 나오는 모달 창*/
        if(Math.floor(paymentInfo.balance - (paymentInfo.balance * 0.1 + Math.floor(paymentInfo.amount* 1.1) * 0.03 + 500)) < 5000) {
            handleFailModal();
            handleClose();
            return;
        }

        if (paymentInfo.paymethod === '무통장입금') {
            const { handleAccountInfoUploadModal } = this.props;
            handleAccountInfoUploadModal();
        } else {
            let data = new FormData();
            data.append('cashPaymentId', paymentInfo.uid);

            apiUtil.asyncRequest({
                setLoading: this.setLoading,
                url: "/api/cash/payment/refund",
                method: apiUtil.requestMethod.POST,
                data: data,
                isFile: true,
                success: (result) => {
                    handleSuccessModal();
                    handleClose();
                }
            })
        }
    }

    render() {
        const { loading } = this.state;
        const { isOpen, handleClose, usageList, paymentInfo } = this.props;
        const { getType, getMomentMessageType } = this;
        const { handleRefund } = this;
        const refundableAmount = Math.max(Math.floor(paymentInfo.balance - (paymentInfo.balance * 0.1 + Math.floor(paymentInfo.amount * 1.1) * 0.03 + 500)), 0);
        const canRequestRefund = paymentInfo.refundable && !paymentInfo.cmpnProcess && refundableAmount >= 5000;

        return (
            <Modal
                open={isOpen}
                handleClose={handleClose}
                modalTitle="이용 내역"
                className="react-full-modal"
            >
                <Loading loading={loading} />
                <div className='modal-body'>
                    {paymentInfo.refundable && refundableAmount >= 5000 && (
                        <div className="info-content-item shadow">
                            <ol className="fs-6 mb-2 fw-modal fs-4 ps-4 ps-sm-5">
                                <li>추가 이용을 희망하지 않는 경우, 잔여 포인트는 환불이 가능합니다.</li>
                                <li>환불은 내부 산정식을 기준으로 진행되며, 산정식에 대한 자세한 사항은 이용약관에서 확인이 가능합니다.</li>
                                <li>환불 가능 금액은 <b
                                    className={"text-danger"}>{stringUtil.formatNumber(refundableAmount)} 원</b> 입니다.
                                </li>
                            </ol>
                            {paymentInfo.cmpnProcess && <li className={"text-danger"}>진행중인 캠페인 포함되어 캠페인이 끝날때 까지 환불을 하실 수 없습니다!</li>}
                        </div>
                    )}
                    <div className='table-responsive mt-4' style={{maxHeight: '400px', overflowY: 'scroll'}}>
                        <table className="table table-bordered">
                            <thead className='table-light'>
                            <tr>
                                <th>일시</th>
                                <th>메시지 명</th>
                                <th>서비스</th>
                                <th>구분</th>
                                <th>건수</th>
                                <th>포인트</th>
                                <th>처리 후 잔여 포인트</th>
                            </tr>
                            </thead>
                            <tbody>
                            {usageList.length === 0 ? (
                                <tr>
                                    <td colSpan="8" className="text-center">NO Data</td>
                                </tr>
                            ) : (
                                usageList.map((item, index) => (
                                    <tr key={index}>
                                        <td className='text-center'>{item.date.slice(0, 10)}</td>
                                        <td>{item.momentAdName || item.name}</td>
                                        <td className='text-center'>{item.momentMessageType ? getMomentMessageType(item.momentMessageType) : item.sendChannel}</td>
                                        <td className='text-center'>{getType(item.type)}</td>
                                        <td className='text-end'>{stringUtil.formatNumber(item.sndCnt)} 건</td>
                                        <td className='text-end'>{stringUtil.formatNumber(item.amount)} P</td>
                                        <td className='text-end'>{stringUtil.formatNumber(item.balance)} P</td>
                                    </tr>
                                ))
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='modal-footer'>
                    {canRequestRefund && (
                        <button className='btn btn-outline-danger btn-md' onClick={handleRefund}>
                            환불신청
                        </button>
                    )}
                </div>
            </Modal>
        )
    }
}

export default PaymentUsageModal;
